const tr = {
  preRegistrationCampaign: {
    attributes: {
      name: 'Nome',
      phone: 'Telefone',
      status: 'Situação',
      step: 'Passo da conversa',
      reason: 'Motivo',
      validation_questions: 'Perguntas feitas',
      sent_at: 'Enviado em',
      delivered_at: 'Entregue em',
      validated_at: 'Validado em',
      quantity: 'Quantidade',
      template_name: 'Template',
      support_phone: 'Telefone de suporte',
    },
    extras: {
      statusTitle: 'Situação da campanha',
      settingsTitle: 'Configurações',
      templateHelp: 'Letras minúsculas, números e _. Para teste A/B, vários separados por vírgula',
      supportPhoneHelp: 'Aparece na mensagem final, com o login e a senha',
      saveTitle: 'Salvar configurações',
      saveConfirm: 'Salvar as configurações da campanha de pré-cadastro?',
      confirm: 'Confirmar',
      saved: 'Configuração salva.',
      batchTitle: 'Enviar lote',
      invitationsTitle: 'Convites',
      refresh: 'Atualizar',
      reload: 'Recarregar',
      people: 'Pessoas',
      dailyLimitReached: 'Limite de {{limit}} envios em 24 horas atingido. Libera mais às {{time}}.',
      sentLast24h: 'Enviados nas últimas 24 horas: {{sent}} de {{limit}}',
      remainingNow: 'Ainda dá para enviar agora: {{remaining}}',
      nextSlot: 'Libera mais às {{time}}',
      sendBatch: 'Enviar lote',
      sendBatchConfirm: 'Enviar o convite para {{count}} pré-cadastro agora?',
      sendBatchConfirm_plural: 'Enviar o convite para {{count}} pré-cadastros agora?',
      batchDone: 'Lote enviado.',
      cancelRun: 'Parar envio',
      cancelRunConfirm: 'Parar o envio do lote agora?',
      runQueued: 'Aguardando o worker...',
      runStale: 'há {{minutes}} min',
      runStalled: 'sem progresso há {{minutes}} min',
      runRunning: 'Enviando...',
      runStopping: 'Parando...',
      statusFilter: 'Situação',
      statusAll: 'Todas as situações',
      groups: {
        audience: 'Público',
        invitations: 'Convites',
        conversations: 'Conversas',
      },
      numbers: {
        pre_registered: 'Pré-cadastros',
        eligible_now: 'Podem receber agora',
        sent: 'Enviados',
        delivered: 'Entregues',
        undeliverable: 'Não entregues',
        failed: 'Falhas',
        skipped: 'Pulados',
        awaiting_answer: 'Aguardando resposta',
        awaiting_choice: 'Aguardando escolha',
        awaiting_validation: 'Aguardando validação',
        declined: 'Recusaram',
        activated: 'Validados (ativos)',
        cancelled: 'Cancelados',
        opted_out: 'Pediram para parar',
        no_response: 'Sem resposta há 3 dias',
      },
      summary: {
        requested: 'Pedidos',
        sent: 'Enviados',
        failed: 'Falhas',
        skipped: 'Pulados',
        stopped_reason: 'Parou por',
        batch_full: 'lote completo',
        exhausted: 'acabaram os elegíveis',
        rate_limited: 'limite da Infobip (429)',
        send_disabled: 'envio desligado',
        consecutive_failures: 'falhas seguidas',
        outside_send_hours: 'fim do horário de envio',
        daily_limit: 'limite de 24 horas atingido',
        cancelled: 'pedido para parar',
        template_paused: 'template pausado pela Meta (7009)',
        error: 'erro no envio',
        no_notify_url: 'worker sem retorno da Infobip',
        worker_late: 'worker não começou a tempo',
        interrupted: 'worker parou no meio',
      },
      statuses: {
        sent: 'Enviado',
        delivered: 'Entregue',
        undeliverable: 'Não entregue',
        failed: 'Falhou',
        skipped: 'Pulado',
      },
      steps: {
        started: 'Aguardando resposta',
        awaiting_consent: 'Aguardando resposta',
        awaiting_patient_choice: 'Aguardando escolha',
        awaiting_birth_month: 'Validando mês do aniversário',
        awaiting_surname: 'Validando sobrenome',
        awaiting_cpf_digits: 'Validando CPF',
        awaiting_mother_name: 'Validando nome da mãe',
        declined: 'Recusou',
        validated: 'Validado',
        already_active: 'Já ativo',
        failed: 'Cancelado',
        opted_out: 'Pediu para parar',
      },
      questions: {
        birth_month: 'Mês do aniversário',
        surname: 'Sobrenome',
        cpf_first_3: 'CPF (3 primeiros)',
        cpf_first_4: 'CPF (4 primeiros)',
        mother_name: 'Nome da mãe',
      },
      reasons: {
        repeated_phone: 'Número repetido no lote',
        already_invited: 'Já convidado',
        phone_in_other_flow: 'Número em conversa da outra campanha',
        send_disabled: 'Envio desligado',
        send_error: 'Erro no envio, será tentado de novo',
        no_settings: 'Tabela de configuração vazia',
        token_invalid: 'Token não pôde ser lido',
        user_not_found: 'Cadastro não encontrado',
        not_invited: 'Não convidado',
        no_cpf: 'Sem CPF',
        invalid_cpf: 'CPF inválido',
        duplicate_cpf: 'CPF repetido em outro cadastro',
        no_validation_data: 'Sem dados para validar',
        birth_month_mismatch: 'Errou o mês do aniversário',
        surname_mismatch: 'Errou o sobrenome',
        cpf_digits_mismatch: 'Errou o CPF',
        mother_name_mismatch: 'Errou o nome da mãe',
        user_mismatch: 'Cadastro não confere',
        run_active: 'Já existe um envio em andamento',
        run_not_active: 'Esse envio já terminou',
      },
    },
  },
};

export default tr;
